import * as React from "react";
const SvgIcon30 = props => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 19.799 19.799" {...props}><g style={{
    stroke: "var(--text-color-3,#000)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.667px",
    fill: "none"
  }} transform="rotate(-45 11.95 4.95)"><circle cx={7} cy={7} r={7} style={{
      stroke: "none"
    }} stroke="none" /><circle cx={7} cy={7} r={6.167} style={{
      fill: "none"
    }} /></g><path transform="rotate(-45 24.642 -8.793)" style={{
    fill: "var(--text-color-3,#000)"
  }} d="M0 0h2v6H0z" /></svg>;
export default SvgIcon30;